'use client'

import type { ButtonHTMLAttributes } from 'react'
import { cx } from './utils/cx'

export function IconButton({ children, className, ...rest }: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button className={cx('st-icon-btn', className)} {...rest}>
      {children}
    </button>
  )
}
